import React from 'react';

import {
  Stack,
  IconButton,
  Icon,
  TRIconType,
} from '@tapresearch/ui/components';

type ToggleItem = {
  icon: TRIconType;
  label: string;
  callback: () => void;
};

interface GraphToggleSwitchProps {
  leftItem: ToggleItem;
  rightItem: ToggleItem;
  selectedItem: 'left' | 'right';
}

export const GraphToggleSwitch = ({
  leftItem,
  rightItem,
  selectedItem = 'left',
}: GraphToggleSwitchProps) => {
  return (
    <Stack data-testid="graph-toggle-switch" direction="row" spacing="0">
      <IconButton
        {...{
          ...commonProps,
          'aria-label': leftItem.label,
          'data-testid':
            selectedItem === 'left'
              ? 'left-toggle-item-selected'
              : 'left-toggle-item',
          rounded: '4px 0 0 4px',
          icon: <Icon boxSize={6} icon={leftItem.icon} />,
          onClick: leftItem.callback,
          ...(selectedItem === 'left' && selectedProps),
        }}
      />
      <IconButton
        {...{
          ...commonProps,
          'aria-label': rightItem.label,
          'data-testid':
            selectedItem === 'right'
              ? 'right-toggle-item-selected'
              : 'right-toggle-item',

          rounded: '0 4px 4px 0',
          icon: <Icon boxSize={6} icon={rightItem.icon} />,
          onClick: rightItem.callback,
          ...(selectedItem === 'right' && selectedProps),
        }}
      />
    </Stack>
  );
};

const commonProps = {
  m: 0,
  px: 5,
  variant: 'outline',
  outline: 0,
  borderColor: 'gray.200',
  color: 'gray.600',
  height: 9,
  minW: 12,
  _focus: {
    boxShadow: 'none',
  },
} as const;

const selectedProps = {
  bg: 'blue.100',
  color: 'blue.500',
  borderColor: 'blue.300',
} as const;
